import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { pageTitle } from "@/components/document-title";
import { VehicleGroupDetailPage } from "@/features/vehicle-groups/pages/vehicle-group-detail-page";
import { vehicleGroupFilterSchema } from "@/features/vehicle-groups/schemas/vehicle-group-filter.schema";

export const Route = createFileRoute(
	"/_authenticated/admin/vehicle-groups/$vehicleGroupId"
)({
	head: () => pageTitle("Vehicle group"),
	component: VehicleGroupDetailPage,
	validateSearch: zodValidator(vehicleGroupFilterSchema),
});
